import { api } from "@shared/api/client";
import type {
  IndicadorControlPayload,
  IndicadorDataPayload,
  IndicadorDetail,
  IndicadorHubItem,
  IndicadorMetadataPayload,
} from "../types/indicadores";

const BASE_URL = "/certificaciones/indicadores";

export const indicadoresApi = {
  async list(): Promise<IndicadorHubItem[]> {
    const { data } = await api.get<{ data: IndicadorHubItem[] }>(BASE_URL);
    return data.data;
  },

  async get(slug: string): Promise<IndicadorDetail> {
    const { data } = await api.get<IndicadorDetail>(`${BASE_URL}/${slug}`);
    return data;
  },

  async updateMetadata(slug: string, payload: IndicadorMetadataPayload): Promise<void> {
    await api.put(`${BASE_URL}/${slug}`, payload);
  },

  async createData(slug: string, payload: IndicadorDataPayload): Promise<void> {
    await api.post(`${BASE_URL}/${slug}/datos`, payload);
  },

  async updateData(slug: string, id: number, payload: IndicadorDataPayload): Promise<void> {
    await api.put(`${BASE_URL}/${slug}/datos/${id}`, payload);
  },

  async deleteData(slug: string, id: number): Promise<void> {
    await api.delete(`${BASE_URL}/${slug}/datos/${id}`);
  },

  async createReference(slug: string, payload: IndicadorDataPayload): Promise<void> {
    await api.post(`${BASE_URL}/${slug}/valores-referencia`, payload);
  },

  async updateReference(slug: string, id: number, payload: IndicadorDataPayload): Promise<void> {
    await api.put(`${BASE_URL}/${slug}/valores-referencia/${id}`, payload);
  },

  async deleteReference(slug: string, id: number): Promise<void> {
    await api.delete(`${BASE_URL}/${slug}/valores-referencia/${id}`);
  },

  async createControl(slug: string, payload: IndicadorControlPayload): Promise<void> {
    await api.post(`${BASE_URL}/${slug}/control-documental`, payload);
  },

  async updateControl(slug: string, id: number, payload: IndicadorControlPayload): Promise<void> {
    await api.put(`${BASE_URL}/${slug}/control-documental/${id}`, payload);
  },

  async deleteControl(slug: string, id: number): Promise<void> {
    await api.delete(`${BASE_URL}/${slug}/control-documental/${id}`);
  },
};
